<mat-card>
    <mat-card-header class="bg-info text-white">
      <mat-card-title>{{ message }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form (ngSubmit)="onSubmit()">
        <br />
        <div *ngFor="let file of filesAdded; let i = index" fxLayoutAlign="center center">
          <mat-form-field>
            <input matInput [placeholder]="'Nuevo nombre del archivo ' + (i + 1)" [(ngModel)]="file.newName"
              [name]="'file_' + i">
          </mat-form-field>
        </div>
        <br />
        <div fxLayoutAlign="center center">
          <dropzone #dropzone class="dropzone-container" [config]="dropzoneConfig" (success)="onUploadSuccess($event)"
            (addedFile)="onAddedFile($event)" (removedFile)="onRemovedFile($event)" fxLayout="row"  (error)="onUploadError($event)"
            fxLayoutAlign="start strech" fxFlex="auto" (maxFilesExceeded)="onMaxFilesExceeded()"></dropzone>
        </div>
      </form>
      <mat-card-actions fxLayoutAlign="center center">
        <button *ngIf="this.filesAdded.length > 0" type="button" [disabled]="clicked" clicked="true;" mat-raised-button
          color="primary" (click)="onSubmit()">
          Subir
        </button>
        <button type="button" mat-raised-button color="warn" (click)="closeDialog()">
          Cancelar
        </button>
      </mat-card-actions>
    </mat-card-content>
  </mat-card>